const algoliaEnv = process.env.ALGOLIA_ENV

// The default materials index
export const materials = `Materials_${algoliaEnv}`

// Materials replica index, sorted alphabetically by titles
export const materialsAlphabetical = `Materials_alphabetical_${algoliaEnv}`

// Materials replica index, sorted by most recent
export const materialsRecent = `Materials_recent_${algoliaEnv}`

// Materials replica index, sorted by ranked material type plus titles
export const materialsRanking = `Materials_ranking_${algoliaEnv}`
